<template>
	<div class="mh-middle">
		<div class="mh-middle-inner">
			<div class="mh-time-top">
				<b-row no-gutters>
					<b-col align-self="center" lg="6" md="12">
						<h2>Plans</h2>
					</b-col>
					<b-col align-self="center" lg="6" md="12">
						<div class="mh-time-search">
							<div class="mh-time-search-inner">
								<i class="mh-icon-search"></i>
								<input type="text" placeholder="Search Here..." v-model="search">
							</div>
						</div>
					</b-col>
				</b-row>
			</div>

			<div v-if="!isViewing" class="mh-middle-container">
				<div class="mh-time-entries-top mh-time-off">
					<b-row class="m-0">
						<b-col cols="12" class="p-0">
							<div class="table-reponsive mh-customers-list">
								<div class="dataTables_wrapper no-footer">
									<data-table v-bind="bindings"
												:showPerPage="false"
												:showEntriesInfo="false"
												:showSearchFilter="false"
												:showPagination="true"
												:showDownloadButton="false"
												sortingMode="single"
												tableClass="table table-curved dataTable"
												ref="dataTable" />
								</div>
							</div>
						</b-col>
					</b-row>
				</div>
			</div>

			<div v-else ref="forms">
				<b-col cols="12" class="p-0">
					<b-card no-body class="mh-card mh-card-page">
						<b-card-header class="mh-bg-primary d-flex align-items-center">
							<h3 class="card-title">Provider Budgets</h3>
							<div class="col-auto ml-auto p-0">
								<button type="button" class="btn btn-link mh-btn-icon" @click="cancelView"><i class="mh-icon-close"></i></button>
							</div>
						</b-card-header>
						<b-card-body class="mh-off-middle">
							<b-row class="mb-2">
								<b-col align-self="center">
									<h5>{{selectedRecord.name}}</h5>
								</b-col>
							</b-row>
							<b-row class="mb-5">
								<b-col align-self="center" class="text-right">
									<div class="mh-add-entry"><button class="btn btn-default" @click="addingNewPmPlanProvider = true">New</button></div>
								</b-col>
							</b-row>
							<b-row class="header">
								<b-col cols="3">
									Name
								</b-col>
								<b-col>
									Service Provider
								</b-col>
								<b-col>
									Budget
								</b-col>
								<b-col>
									Utilised
								</b-col>
								<b-col>
									Balance
								</b-col>
								<b-col>
									Start Date
								</b-col>
								<b-col>
									To Date
								</b-col>
							</b-row>
							<b-row v-for="(pmPlanProvider, i) in pmPlanProviders" :key="i" class="mb-2">
								<b-col cols="3">
									{{pmPlanProvider.name}}
								</b-col>
								<b-col>
									{{pmPlanProvider.serviceprovidername}}
								</b-col>
								<b-col>
									{{pmPlanProvider.budget||0 | currency}}
								</b-col>
								<b-col>
									{{pmPlanProvider.utilised||0 | currency}}
								</b-col>
								<b-col>
									{{pmPlanProvider.balance||0 | currency}}
								</b-col>
								<b-col>
									{{pmPlanProvider.startdate ? moment(pmPlanProvider.startdate, "DD/MM/YYYY hh:mm:ss A").format("DD/MM/YYYY") : "-"}}
								</b-col>
								<b-col>
									{{pmPlanProvider.enddate ? moment(pmPlanProvider.enddate, "DD/MM/YYYY hh:mm:ss A").format("DD/MM/YYYY") : "-"}}
								</b-col>
							</b-row>
						</b-card-body>
					</b-card>
				</b-col>
			</div>
		</div>

		<b-modal :visible="addingNewPmPlanProvider" @hide="addingNewPmPlanProvider = false" modal-class="shift-summary" body-class="mh-off-middle" size="lg" hide-footer>
			<template slot="modal-title">
				<h5 class="modal-title">Add new Provider Budget</h5>
			</template>
			<template slot="default">
				<b-row>
					<b-col md="4">
						<label class="mh-label required">Service Provider</label>
						<div class="field-with-icon">
							<vue-typeahead-bootstrap :data="accounts"
													 :serializer="s => s.name"
													 @hit="accountId = $event.id; serviceTypeCategoryId = null; $refs.serviceTypeCategoryId.inputValue = '';"
													 @keyup="($event) => {
														if($refs.accountId.inputValue == '') {
															accountId = null;
															serviceTypeCategoryId = null;
															$refs.serviceTypeCategoryId.inputValue = '';
														}
														}"
													 autocomplete="off"
													 :showOnFocus="true"
													 :minMatchingChars="1"
													 ref="accountId"></vue-typeahead-bootstrap>
							<i class="mh-icon-search"></i>
						</div>
					</b-col>
					<b-col md="4">
						<label class="mh-label">Category</label>
						<div class="field-with-icon">
							<vue-typeahead-bootstrap :data="accountId == null ? [] : serviceTypeCategories"
													 :serializer="s => s.name"
													 @hit="serviceTypeCategoryId = $event.id; getMaxBudget();"
													 @keyup="($event) => { $refs.serviceTypeCategoryId.inputValue != '' ? '' : itemId = null }"
													 autocomplete="off"
													 :showOnFocus="true"
													 :minMatchingChars="1"
													 :placeholder="accountId == null ? 'Select a Service Provider first' : (serviceTypeCategories.length < 1 ? 'No categories available' : '')"
													 ref="serviceTypeCategoryId"></vue-typeahead-bootstrap>
							<i class="mh-icon-search"></i>
						</div>
					</b-col>
					<b-col md="4">
						<label class="mh-label required">Budget</label>
						<b-input type="number" v-model="budget" :max="maxBudget" :state="budget > 0 && budget <= maxBudget"></b-input>
					</b-col>
				</b-row>
				<b-row>
					<b-col md="4">
						<label class="mh-label required">Start Date</label>
						<div class="mh-time-entry">
							<div class="mh-datepicker">
								<datepicker v-model="startDate" :disabled-dates="{ to: moment().toDate() }" />
								<i class="mh-icon-calendar"></i>
							</div>
						</div>
					</b-col>
					<b-col md="4">
						<label class="mh-label required">End Date</label>
						<div class="mh-time-entry">
							<div class="mh-datepicker">
								<datepicker v-model="endDate" :disabled-dates="{ to: moment(startDate).toDate() }" />
								<i class="mh-icon-calendar"></i>
							</div>
						</div>
					</b-col>
				</b-row>
				<b-row class="mh-action-nav">
					<b-col cols="6">
						<button class="btn btn-default btn-grey" @click="addingNewPmPlanProvider = false">Close</button>
					</b-col>
					<b-col cols="6">
						<button class="btn btn-default" @click="onSaveNewPmPlanProviderClick">Save</button>
					</b-col>
				</b-row>
			</template>
		</b-modal>
	</div>
</template>

<script>
	import ContentTitle from "./partials/ContentTitle"
	import SortingIcon from "./partials/SortingIcon"
	import TableRowActions from "./partials/TableRowActions"
	import { bus } from "./../main"
	import moment from "moment"

	export default {
		name: 'PlansContent',
		components: {
			ContentTitle,
			SortingIcon,
			TableRowActions
		},
		data: function () {
			return {
				search: "",
				viewing: false,
				selectedRecord: {},
				addingNewPmPlanProvider: false,
				accountId: null,
				serviceTypeCategoryId: null,
				budget: null,
				maxBudget: null,
				startDate: null,
				endDate: null
			}
		},
		mounted: function () {
			this.$store.dispatch("Plans/getPmPlans")

			bus.$off('viewDetailsTableRowAction')
			bus.$on('viewDetailsTableRowAction', obj => { this.viewRow(obj) })
		},
		watch: {
			search: {
				immediate: true,
				handler(newValue, oldValue) {
					if (this.$refs.dataTable != null) {
						this.$refs.dataTable.search = newValue
						this.$refs.dataTable.setSearch()
					}
				}
			}
		},
		computed: {
			isViewing: function () { return this.viewing },
			records: function () {
				var icons = [
					{
						class: "mh-icon-eye",
						title: "View",
						emit: "viewDetailsTableRowAction"
					}
				]

				return this.$store.state.Plans.pmPlans
					.map(x => {
						return {
							id: x.id,
							name: x.name,
							icons: icons
						}
					})
					.filter(x => {
						return (x.name + "").toLowerCase().indexOf(this.search.toLowerCase()) > -1
					})
			},
			columns: function () {
				var columns = [
					{ key: "name", title: "Name", searchable: true, sortable: true },
					{ key: "", title: "", component: TableRowActions }
				]

				return columns
			},
			bindings: function () {
				return {
					SortingIconComponent: SortingIcon,
					columns: this.columns,
					data: this.records
				}
			},
			pmPlanProviders: function () { return this.$store.state.Plans.pmPlanProviders },
			accounts: function () { return this.$store.state.Accounts.accounts },
			serviceTypeCategories: function () {
				return this.$store.state.ServiceTypeCategories.serviceTypeCategories
					.filter(x => this.$store.state.Plans.pmPlanBudgets.some(y => y.categoryid === x.id))
			},
			isAccountIdValid: function () {
				if (this.accountId == null) {
					this.$store.commit("Toasts/showError", { title: "Service Provider", content: "Service Provider is required" })

					return false
				}

				return true
			},
			isServiceTypeCategoryIdValid: function () {
				if (this.serviceTypeCategoryId == null) {
					this.$store.commit("Toasts/showError", { title: "Category", content: "Category is required" })

					return false
				}

				return true
			},
			isBudgetValid: function () {
				if (this.budget == null || this.budget === "") {
					this.$store.commit("Toasts/showError", { title: "Budget", content: "Budget is required" })

					return false
				}

				if (this.budget <= 0) {
					this.$store.commit("Toasts/showError", { title: "Budget", content: "Budget cannot be less than zero" })

					return false
				}

				if (this.budget > this.maxBudget) {
					this.$store.commit("Toasts/showError", { title: "Budget", content: "Budget cannot be greater than $" + this.maxBudget })

					return false
				}

				return true
			},
			isStartDateValid: function () {
				if (this.startDate == null) {
					this.$store.commit("Toasts/showError", { title: "Start Date", content: "Start Date is required" })

					return false
				}

				return true
			},
			isEndDateValid: function () {
				if (this.endDate == null) {
					this.$store.commit("Toasts/showError", { title: "End Date", content: "End Date is required" })

					return false
				}

				return true
			}
		},
		methods: {
			setSelectedRecord: function (id) {
				this.selectedRecord = this.records.filter(x => x.id == id)[0]
			},
			cancelView: function () {
				this.viewing = false
				this.selectedRecord = null
			},
			viewRow: function (obj) {
				var $this = this

				this.$store.dispatch("Plans/getPmPlanProviders", obj.id).then(function () {
					$this.$store.dispatch("Plans/getPmPlanBudgets", obj.id).then(function () {
						$this.viewing = true
						$this.setSelectedRecord(obj.id)
					})
				})
			},
			isFormValid: function () {
				return this.isAccountIdValid
					&& this.isServiceTypeCategoryIdValid
					&& this.isBudgetValid
					&& this.isStartDateValid
					&& this.isEndDateValid
			},
			onSaveNewPmPlanProviderClick: function () {
				if (!this.isFormValid())
					return

				var account = this.accounts.filter(x => x.id === this.accountId)[0];
				var serviceTypeCategory = this.serviceTypeCategories.filter(x => x.id === this.serviceTypeCategoryId)[0];

				var parameters = {
					id: 0,
					name: `${account.name} - ${serviceTypeCategory.name}`,
					serviceProviderId: this.accountId,
					categoryId: this.serviceTypeCategoryId,
					pmPlanId: this.selectedRecord.id,
					budget: this.budget,
					startDate: moment(this.startDate, "DD/MM/YYYY h:mm:ss A").format("YYYY-MM-DD"),
					endDate: moment(this.endDate, "DD/MM/YYYY h:mm:ss A").format("YYYY-MM-DD")
				}

				var $this = this

				this.$store.dispatch("Plans/savetPmPlanProvider", parameters).then(function () {
					$this.addingNewPmPlanProvider = false
					$this.viewRow($this.selectedRecord)
				})
			},
			getMaxBudget: function () {
				var $this = this

				var parameters = {
					pmPlanId: this.selectedRecord.id,
					categoryId: this.serviceTypeCategoryId,
					id: 0
				}

				this.$store.dispatch("Plans/getMaxBudget", parameters).then(function (budget) {
					$this.maxBudget = budget <= 0 ? null : budget
				})
			}
		}
	};
</script>

<style scoped>
	.header > div {
		font-weight: bold;
	}
</style>